import { Venue as GQLItem } from '../../../generated/api.graphql';
import { take } from '../../../util';
import * as Address from '../Address/Address';
import * as Attachment from '../Attachment/Attachment';
import * as DefaultSet from '../DefaultSet/DefaultSet';
import * as VenueRoom from './VenueRoom';

export type Venue = {
  id?: number;
  name?: string;
  url?: string;
  timezone?: string;
  currency?: string;
  locale?: string;
  salesTax?: number;
  processingFee?: number;
  processingFeePercentage?: number;
  includeCcFee?: boolean;
  includeTaxFee?: boolean;
  includeConvenienceFee?: boolean;
  replyTo?: string;
  address?: Address.Address;
  rooms?: VenueRoom.VenueRoom[];
  logoId?: number;
  logo?: Attachment.Attachment;
  defaultSet?: DefaultSet.DefaultSet;
};

export const fromGql = (item: GQLItem): Venue => ({
  ...take<Venue>(
    item,
    'id',
    'name',
    'url',
    'timezone',
    'currency',
    'locale',
    'salesTax',
    'processingFee',
    'processingFeePercentage',
    'includeCcFee',
    'includeTaxFee',
    'includeConvenienceFee',
    'replyTo',
    'logoId',
  ),
  address: item.address ? Address.fromGql(item.address) : undefined,
  rooms: item.rooms ? item.rooms.map(VenueRoom.fromGql) : [],
  logo: item.logo ? Attachment.fromGql(item.logo) : undefined,
  defaultSet: item.defaultSet ? DefaultSet.fromGql(item.defaultSet) : undefined,
});
